/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Prompts } from './prompts';

export interface HOAIRule { 
    id?: string;
    name?: string;
    readableName?: string;
    servicePhase?: HOAIRule.ServicePhaseEnum;
    serviceType?: HOAIRule.ServiceTypeEnum;
    discipline?: HOAIRule.DisciplineEnum;
    guideline?: HOAIRule.GuidelineEnum;
    userConfirmationAllowed?: boolean;
    tooltip?: string;
    deleted?: boolean;
    prompts?: Prompts;
    classifications?: Array<string>;
}
export namespace HOAIRule {
    export type ServicePhaseEnum = 'LPH1' | 'LPH2' | 'LPH3' | 'LPH4' | 'LPH5' | 'LPH6' | 'LPH7' | 'LPH8' | 'LPH9';
    export const ServicePhaseEnum = {
        LPH1: 'LPH1' as ServicePhaseEnum,
        LPH2: 'LPH2' as ServicePhaseEnum,
        LPH3: 'LPH3' as ServicePhaseEnum,
        LPH4: 'LPH4' as ServicePhaseEnum,
        LPH5: 'LPH5' as ServicePhaseEnum,
        LPH6: 'LPH6' as ServicePhaseEnum,
        LPH7: 'LPH7' as ServicePhaseEnum,
        LPH8: 'LPH8' as ServicePhaseEnum,
        LPH9: 'LPH9' as ServicePhaseEnum
    };
    export type ServiceTypeEnum = 'GL' | 'BL' | 'OTHER' | 'CUSTOM';
    export const ServiceTypeEnum = {
        GL: 'GL' as ServiceTypeEnum,
        BL: 'BL' as ServiceTypeEnum,
        OTHER: 'OTHER' as ServiceTypeEnum,
        CUSTOM: 'CUSTOM' as ServiceTypeEnum
    };
    export type DisciplineEnum = 'ARC' | 'MEP';
    export const DisciplineEnum = {
        ARC: 'ARC' as DisciplineEnum,
        MEP: 'MEP' as DisciplineEnum
    };
    export type GuidelineEnum = 'HOAI' | 'VDI';
    export const GuidelineEnum = {
        HOAI: 'HOAI' as GuidelineEnum,
        VDI: 'VDI' as GuidelineEnum
    };
}